import { type RefObject, useEffect } from "react";

/**
 * While open: the page behind does not scroll and the search field takes the focus (on the next
 * frame, once the portal is painted). On closing, the page scrolls again and the focus returns to
 * where it was before opening.
 */
export function usePaletteFocus(open: boolean, inputRef: RefObject<HTMLInputElement | null>): void {
  useEffect(() => {
    if (!open) return;
    const previouslyFocused = document.activeElement as HTMLElement | null;
    const { overflow } = document.body.style;
    document.body.style.overflow = "hidden";
    const frame = requestAnimationFrame(() => inputRef.current?.focus());
    return () => {
      cancelAnimationFrame(frame);
      document.body.style.overflow = overflow;
      previouslyFocused?.focus?.();
    };
  }, [open, inputRef]);
}
